<template>
  <div data-cy="DeviceForm">
    <VTextField
      v-model="data.version"
      :label="`${$t('deviceForm.step1.version')}`"
      :rules="{ min: 1, max: 50 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.description"
      :label="$t('deviceForm.step1.description')"
      :rules="{ max: 200 }"
      outlined
      @input="updateData"
    />
    <div
      class="image-manager"
    >
      <FileManager
        :backendFiles="[data.file]"
        :mimetype="acceptedFileMimetype.ZIP"
        :canAdd="hasPermission('files.add')"
        :canEdit="hasPermission('files.edit')"
        :canView="hasPermission('files.view')"
        :canRemove="hasPermission('files.remove')"
        :isSingleFile="true"
        :onDeleteFile="removeFile"
        :actionsDisplayOverWrite="['save', 'delete']"
        @fileAdded="handleFileAdded"
        @change="onDeviceImageSelection"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import FileManager from '@/components/shared/FileManager.vue';
import acceptedFileMimetype from '@/constants/acceptedFileMimetype';
import { cloneDeep } from 'lodash';

export default {
    components: {
        VTextField,
        FileManager,
    },
    props: {
        device: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            data: { version: null, file: null, description: null },
            loading: false,
        };
    },
    computed: {
        acceptedFileMimetype() {
            return acceptedFileMimetype;
        },
        ...mapGetters([
            'userLang',
            'hasPermission',
        ]),
    },
    async created() {
        this.data = { ...this.data, ...cloneDeep(this.device.firmware), id: this.device.id };
    },
    methods: {
        async handleFileAdded(newFile) {
            // Update backendFiles to include the new file
            this.data.selectedImage = newFile;
            this.$emit('sendData', this.data);
            const { data: deviceType } = await this.$rq.getDeviceById(this.data.id);
            this.prepareDeviceTypeOnEdit(deviceType);
        },
        prepareDeviceTypeOnEdit(deviceType) {
            this.data = deviceType;
            this.prepareDescriptions();
            this.data.analysisTypes = this.data?.analysisTypes?.map(({ id }) => id);
        },
        updateData(file) {
            this.$emit('sendData', { firmware: { ...this.data, file: file.id || this.data.file?.id } });
        },
        async onDeviceImageSelection(fileVal) {
            this.updateData(fileVal);
        },
        async removeFile() {
            await this.$rq.deleteDeviceFirmware(this.data.id);
            const { data: deviceType } = await this.$rq.getDeviceById(this.data.id);
            this.prepareDeviceTypeOnEdit(deviceType);
        },
    },
};
</script>
